import React from 'react'
import classNames from 'classnames'

import { Props as FilterProps } from './Filters'
import { BaseCourseCardType } from './CourseCard'

import CourseCard from './CourseCard'
import Filters from './Filters'
import HeadlineThree from '../00-Primitives/Headlines/HeadlineThree'

import style from './style.scss'

// type CardWithOptionalFilters = BaseCourseCardType & {
//   [key: string]: Array<string>
// }

export type Props = {
  cards: Array<BaseCourseCardType>
  className?: ''
  noResultsFoundText: string
  showFilters?: boolean
} & FilterProps

FilterableCourses.defaultProps = {
  className: '',
  showFilters: false,
}

function FilterableCourses(props: Props) {
  const {
    cards,
    className,
    filters,
    handleFilterChange,
    noResultsFoundText,
    showFilters,
    state,
  } = props
  return (
    <div className={classNames(style.wrapper, className)}>
      {showFilters && (
        <Filters
          filters={filters}
          handleFilterChange={handleFilterChange}
          state={state}
        />
      )}
      <div className={style.cardContainer}>
        {cards.length > 0 ? (
          cards.map((card) => (
            <CourseCard
              key={card.headerText}
              className={style.cards}
              {...card}
            />
          ))
        ) : (
          <HeadlineThree className={style.headline}>
            {noResultsFoundText}
          </HeadlineThree>
        )}
      </div>
    </div>
  )
}

export default FilterableCourses
